import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import Table from '../../../../components/tables/Table';
import { SET_VIEW_READ_ONLY } from '../../../../components/context/reducer/actionTypes';
import useTableActions from '../../../../hooks/useTableActions';
import useHasPermission from '../../../../hooks/useHasPermission';
import ListsContainer from '../../../../components/ListsContainer/ListsContainer';

const IntervalList = () => {
  const history = useHistory();
  const [pageSize, setPageSize] = useState(10);
  const tableRef = useRef(null);
  const { globalDispatch, fetchItem } = useContext(DashboardPanelContext);
  const [columns, setColumns] = useState([]);
  const [key, setKey] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchItem({
      modelName: `/intervals`,
      showLoader: true,
    }).then((response) => {
      if (response) {
        setData(response.data);
      }
    });
    setColumns([
      {
        title: 'From',
        field: 'min',
        filtering: false,
        sorting: false,
      },
      {
        title: 'To',
        field: 'max',
        filtering: false,
        sorting: false,
      },
    ]);
    setKey(key + 1);
  }, []);

  const actions = useTableActions({
    updatePermission: 'ADMIN',
    deletePermission: '',
    editURL: '/order-management/interval/',
    removePATH: 'intervals',
    tableRef,
  });

  const handleCreate = () => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: false });
    history.push('/order-management/interval');
  };

  const onRowClick = (event, rowData) => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: true });
    history.push(`/order-management/interval/${rowData.id}`);
  };

  return (
    <ListsContainer>
      <Table
        key={key}
        title='Visit Interval List'
        columns={columns}
        createSlug='Add Visit Interval'
        exportCsv={false}
        actions={actions}
        createAction={useHasPermission('ADMIN') ? handleCreate : undefined}
        tableRef={tableRef}
        data={data}
        onRowClick={onRowClick}
        onChangeRowsPerPage={(pgSize) => {
          setPageSize(pgSize);
        }}
        pageSize={pageSize}
        filtering={false}
        sortableColumns
      />
    </ListsContainer>
  );
};

export default IntervalList;
